window.dataLayer = window.dataLayer || [];
// Set an interval to check for the wishlist button
let checkInterval = setInterval(() => {
    let wishlistButtonContainer = document.querySelector(".product-gallery .gw-add-to-wishlist-product-card-placeholder");

    if (wishlistButtonContainer && wishlistButtonContainer.shadowRoot) {
        let wishlistButton = wishlistButtonContainer.shadowRoot.querySelector(".gw-toggle-wishlist-product-card-button");

        if (wishlistButton) {
            wishlistButton.addEventListener("click", function (event) {
                let isInWishlist = wishlistButton.getAttribute("data-in-wishlist");

                if (isInWishlist === "false") {
                    let productTitleElement = document.querySelector(".product-info__block-item .product-title"),
                        productTitle = wishlistButtonContainer.getAttribute('data-product-title'),
                        productSku = wishlistButtonContainer.getAttribute('data-product-sku'),
                        productVendor = wishlistButtonContainer.getAttribute('data-product-vendor'),                        
                        productType = wishlistButtonContainer.getAttribute('data-product-type'),
                        productVariant = wishlistButtonContainer.getAttribute('data-product-variant'),
                        variantID = wishlistButtonContainer.getAttribute('data-variant-id'),    
                        currency = wishlistButtonContainer.getAttribute('data-currency'),
                        CollectionTitle = wishlistButtonContainer.getAttribute('data-product-collection'),
                        productUrl = wishlistButtonContainer.getAttribute("data-producturl"),
                        productId = wishlistButtonContainer.getAttribute("data-productid"),
                        productPriceElement = document.querySelector(".product-info__block-item[data-block-type='price']").querySelector('sale-price'),
                        productPriceHTML = productPriceElement.innerHTML,
                        splitContent = productPriceHTML.split("</span>"),
                        // productPrice = splitContent[1].trim();
                        productPrice = wishlistButtonContainer.getAttribute('data-product-price');


                    window.dataLayer.push({
                        'event': 'add_to_wishlist_old',
                        'ecommerce': {
                        'currency': currency,
                        'value': productPrice,
                            'items': [{
                                'item_id': productId,
                                'item_url': productUrl,
                                'item_name': productTitle,
                                'price_original': productPrice

                            }]                            
                        }
                    });
                  
                    window.dataLayer.push({
                        'event': 'add_to_wishlist',
                        'ecommerce': {
                        'currency': currency,
                        'value': productPrice,
                            'items': [{
                                'item_id': productId,
                                'item_url': productUrl,
                                'item_name': productTitle,
                                'item_sku': productSku,
                                'item_type': productType,
                                'item_brand': productVendor,
                                'item_variant': productVariant,
                                'price': productPrice,
                                'currency': currency,
                                'discount': 'null',
                                'item_category': CollectionTitle
                            }]                            
                        }
                    });

                }
            });
            clearInterval(checkInterval);
        }
    } else {
        // console.log("Wishlist button not found, retrying...");
    }
}, 500);

let productUrls = document.querySelectorAll(".product-card__media");
if(productUrls.length){
  productUrls.forEach((productUrl) => {
    productUrl.addEventListener("click", function (event) {
        let productCard = productUrl.closest(".product-card"),
            collectionTitle = productCard.getAttribute('data-collection-title'),
            productSku = productCard.getAttribute('data-product-sku'),
            productVendor = productCard.getAttribute('data-product-vendor'),
            productIndex = productCard.getAttribute('data-product-index'),
            productType = productCard.getAttribute('data-product-type'),
            productVariant = productCard.getAttribute('data-product-variant'),
            variantID = productCard.getAttribute('data-variant-id'),      
            currency = productCard.getAttribute('data-currency'),
            productID = productUrl.closest(".product-card").querySelector(".product-card__quick-add-button").getAttribute("data-product-id"),
            productName = productUrl.closest(".product-card").querySelector(".product-card__quick-add-button span").innerHTML,
            productURL = productCard.querySelector('.product-card__media').href || "No URL available",
            productPriceElement = document.querySelector(".product-card__info sale-price"),
            productPriceHTML = productPriceElement.innerHTML,
            splitContent = productPriceHTML.split("</span>"),
            productPricetext = splitContent[1].trim(),
            mainproductPrice = parseFloat(productPricetext.replace(/[^\d,.-]+/g, '').replace(',', '.')) || 0;
            productPrice = mainproductPrice + " " + currency
            variantButtons = productCard.querySelectorAll(".color_swatch button[productdata]"),
            variantIds = Array.from(variantButtons).map((button) => button.getAttribute("productdata"));
      
        window.dataLayer.push({ 'ecommerce': null });
        window.dataLayer.push({
          'event': 'select_item_old',
          'ecommerce': {
            'item_list_name': collectionTitle,
            'currency': currency,
            'value': productPrice,
            'items': [
              {
                'item_id': productID,
                'item_url': productURL,
                'item_name': productName,
                'price_original': productPrice,
              },
            ],
          },
      });

      window.dataLayer.push({
          'event': 'select_item',
          'ecommerce': {
            'item_list_name': collectionTitle,
            'currency': currency,
            'value': productPrice,
            'items': [
              {
                'item_id': productID,
                'item_url': productURL,
                'item_name': productName,                
                'item_brand': productVendor,
                'index': productIndex,
                'item_type': productType,
                'price': productPrice,
                'item_sku': productSku,
                'item_variant': productVariant,
                'item_variant_id': variantID,
                'item_category': collectionTitle,
                'discount': 'null'
              },
            ],
          },
      });
    });
});  
}


// REFUND DATA LAYER
if(document.querySelectorAll('.js-return-btn').length){
  function processOrderData(orderId) {   
    const orderDataScript = document.getElementById('orderData');
    if (!orderDataScript) {
      console.error('Order data not found');
      return;
    }

    const orderData = JSON.parse(orderDataScript.textContent);
    if (!orderData.orders || orderData.orders.length === 0) {
      console.error('No orders available');
      return;
    }

    const order = orderData.orders.find(order => order.id === parseInt(orderId));
    if (!order) {
      console.error(`Order with ID ${orderId} not found`);
      return;
    }

    const googleAnalyticsProducts = [];

    order.line_items.forEach((item, index) => {
      const lineItem = {
        item_id: item.id,
        item_name: item.title,
        affiliation: 'ysabelmora',
        index: index + 1,
        item_brand: item.vendor || 'Unknown',
        item_category: item.product_type || 'Default',
        item_variant: item.variant_title || 'Default',
        price: parseFloat(item.price),
        quantity: item.quantity,
        currency: order.currency || 'EUR',
      };

      googleAnalyticsProducts.push(lineItem);
    });

    const dataLayerObj = {
      event: 'refund',
      ecommerce: {
        currency: order.currency || 'EUR',
        value: parseFloat(order.total_price),
        items: googleAnalyticsProducts,
      },
    };
  
    console.log('DataLayer Object:', dataLayerObj);
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(dataLayerObj);
    Shopify.analytics.publish("custom_event", { 'ecommerce': null });//push al custom event de Shopify
    Shopify.analytics.publish("custom_event", dataLayerObj); //push al custom event de Shopify
  }
  
  document.querySelectorAll('.js-return-btn').forEach(button => {
    button.addEventListener('click', function () {
      const orderId = this.getAttribute('data-order-id');
      console.log("orderId",orderId)
      processOrderData(orderId);
    });
  });
}
let globlePge = document.querySelector("body").getAttribute("data-page-type");
let globlevalue = globlePge.includes("index") ? "home" : globlePge;

// HOME + LANDING. SELECT_CONTENT
let slideshowCarousel = document.querySelectorAll("slideshow-carousel");

if (slideshowCarousel.length) {
  slideshowCarousel.forEach((item) => {
    item.addEventListener("click", function(event) {
      console.log(item.getAttribute("data-backed_using_text"))
      let targetElement = event.target; // The actual clicked element
      let collectionUrl = item.querySelector(".image_inner a")?.href || "";
      let content = item.querySelector(".content-over-media")?.getAttribute("data-block-heading");
      let imagesUrl = item.querySelector(".image_inner img")?.src || "";
      let buttonUrl = item.querySelector(".button-group a")?.href || "";
      let buttonText = item.querySelector(".button-group a")?.innerText || "No button text found";
      let positionsection = item.getAttribute("data-backed_using_text")

      // Determine the clicked element type
      let elementType = "unknown";
      if (targetElement.tagName === "IMG") {
        elementType = "image";
      } else if (targetElement.tagName === "A") {
        elementType = "link";
      } else if (targetElement.tagName === "BUTTON") {
        elementType = "button";
      }

      // Get the link text dynamically
      let linkText = targetElement.innerText.trim() || buttonText
      window.dataLayer.push({
        'event': 'select_content',
        'content_type': content,
        'action_type': 'click_on_collection',
        'element': elementType,
        'position': positionsection,
        'link_text': linkText,
        'page_category': globlevalue,
        'url_destination': buttonUrl
      });
      Shopify.analytics.publish("custom_event", {
        'event': 'select_content',
        'content_type': content,
        'action_type': 'click_on_collection',
        'element': elementType,
        'position': positionsection,
        'link_text': linkText,
        'page_category': globlevalue,
        'url_destination': buttonUrl
      }); //push al custom event de Shopify
    });
  });
}



// Header MENU
let nav = document.querySelector("nav");
let urlcontents = document.querySelector("ul.contents");
if (urlcontents) {
  urlcontents.querySelectorAll(".header__primary-nav-item").forEach((item) => {
    let secondItem = item.querySelector(".header__dropdown-menu");
    if (secondItem) {
      secondItem.querySelectorAll("li a").forEach((e) => {
        e.addEventListener("click", function (ele) {
          let closestDetails = e.closest("li details");
          let closestSummary = closestDetails ? closestDetails.querySelector("summary .h-stack") : null;
          let itemSummary = item ? item.querySelector("summary") : null;         
          window.dataLayer.push({
            'event': 'select_content',
            'content_type': `${itemSummary ? itemSummary.innerText : null}`,
            'action_type': 'click_on_link',
            'element' : 'link',
            'position' : 'head-link',
            'menu_level': `menu_level${e.closest('ul').getAttribute('data-level')}`, 
            'link_text' : e.innerHTML,
            'page_category' : globlevalue,
            'url_destination' : e.href
        });
          Shopify.analytics.publish("custom_event", {
            'event': 'select_content',
            'content_type': `${itemSummary ? itemSummary.innerText : null}`,
            'action_type': 'click_on_link',
            'element' : 'link',
            'position' : 'head-link',
            'menu_level': `menu_level${e.closest('ul').getAttribute('data-level')}`, 
            'link_text' : e.innerHTML,
            'page_category' : globlevalue,
            'url_destination' : e.href
        }); //push al custom event de Shopify
        console.log(  window.dataLayer,"  window.dataLayer.push  window.dataLayer.push  window.dataLayer.push")
        });
      });
    }
  });
}

// FOOTER. SELECT_CONTENT 
if(document.querySelectorAll(".footer__block--links a").length){  
  document.querySelectorAll(".footer__block--links  a").forEach(link => {
    link.addEventListener("click", function (e) {
        const linkText = this.textContent.trim();
        const linkHref = this.href;
        const parentBlock = this.closest(".footer__block");
        const parentTitle = parentBlock ? parentBlock.querySelector("p.h6")?.textContent.trim() : "No title found";
        window.dataLayer.push({
          'event': 'select_content',
          'content_type': parentTitle ,
          'action_type': 'click_on_link',
          'element' : 'link',
          'position' : 'footer-link',
          'link_text' : linkText,
          'page_category' : globlevalue,
          'url_destination' : linkHref
      });
        Shopify.analytics.publish("custom_event", {
          'event': 'select_content',
          'content_type': parentTitle ,
          'action_type': 'click_on_link',
          'element' : 'link',
          'position' : 'footer-link',
          'link_text' : linkText,
          'page_category' : globlevalue,
          'url_destination' : linkHref
      }); //push al custom event de Shopify
    });
  });
}

// FOOTER Social Media
if(document.querySelectorAll(".footer__block .social-media li").length){  
  document.querySelectorAll(".footer__block .social-media li").forEach((item) => {
    item.addEventListener("click", function (e) {
        const link = this.querySelector("a");
        if (link){
            const url = link.href;
            const classList = Array.from(this.classList);
            const brandingClass = classList.find(cls => cls.startsWith("branding-colors--"));
            const socialName = brandingClass ? brandingClass.replace("branding-colors--", "") : "Unknown";
  
            console.log("URL:", );
            console.log("Selected Social Media:", socialName);
            window.dataLayer.push({
              'event': 'select_content',
              'content_type': "welcome_to_yourself" ,
              'action_type': 'click_on_icon',
              'element' : 'icon',
              'position' : 'footer-icon',
              'link_text' : socialName,
              'page_category' : globlevalue,
              'url_destination' : url
          });
          Shopify.analytics.publish("custom_event", {
              'event': 'select_content',
              'content_type': "welcome_to_yourself" ,
              'action_type': 'click_on_icon',
              'element' : 'icon',
              'position' : 'footer-icon',
              'link_text' : socialName,
              'page_category' : globlevalue,
              'url_destination' : url
          }); //push al custom event de Shopify
        }
    });
  });
}

// FORMULARIO NEWSLETTER. FORM_START
(function checkFormAndInit() {
  var interval = setInterval(function () {
    var form = document.querySelector(".footer_connectif_form form");
    if (!form) return;

    clearInterval(interval);

    var emailInput = form.querySelector('input[type="email"]');
    var checkboxes = form.querySelectorAll('input[type="checkbox"]');
    var formStarted = false;
    var formSubmitted = false;

    function pushToDataLayer(eventData) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventData);
      Shopify.analytics.publish("custom_event",eventData); //push al custom event de Shopify
    }

    function handleFormStart() {
      if (!formStarted) {
        formStarted = true;
        pushToDataLayer({
          event: "form_start",
          content_type: "suscribete_a_nuestra_newsletter",
          position: "footer-link",
          form_name: "newsletter_footer",
          form_id: form.closest('.footer_connectif_form').getAttribute("id") || "null",
          url_destination: null,
        });
      }
    }

    if (emailInput) {
      emailInput.addEventListener("input", handleFormStart);
    }
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener("change", handleFormStart);
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      const { formHasError, errorFields } = checkErrors();

      if (formHasError) {
        pushToDataLayer({
          event: "form_error",
          content_type: "suscribete_a_nuestra_newsletter",
          position: "footer-link",
          form_name: "newsletter_footer",
          form_id: form.closest('.footer_connectif_form').getAttribute("id") || "Connectif_form",
          error_fields: errorFields,
          url_destination: null,
        });
        console.log("Form submission prevented due to errors:", errorFields);
        return;
      }

      if (!formSubmitted) {
        formSubmitted = true;
        pushToDataLayer({
          event: "form_submit",
          content_type: "suscribete_a_nuestra_newsletter",
          position: "footer-link",
          form_name: "newsletter_footer",
          form_id: "Connectif_form",
          // form_id: form.closest('.footer_connectif_form').getAttribute("id") || "null",
          url_destination: null,
        });
      }
    });
  }, 500);
})();

function checkErrors() {
  let formHasError = false;
  let errorFields = [];

  document.querySelectorAll("[data-cn-required-message-for]").forEach(function (errorDiv) {
    if (errorDiv.offsetParent !== null) {
      formHasError = true;
      let fieldName = errorDiv.getAttribute("data-cn-required-message-for");
      errorFields.push(fieldName);
    }
  });

  return { formHasError, errorFields };
}

// Área Profesional 

// (function newcheckFormAndInit() {
//   var interval = setInterval(function () {
//     var form = document.querySelector(".globo-form-app form");
//     if (!form) return;

//     clearInterval(interval);

//     var checkboxes = form.querySelectorAll('input[type="radio"], input[type="checkbox"]');
//     var inputs = form.querySelectorAll('input');
//     var requiredFields = form.querySelectorAll(".globo-form-control input[presence]");
//     var requiredFieldsRadio3 = form.querySelectorAll('.globo-form-control input[name="radio-3"]');
//     var submitButton = form.querySelector('.globo-formbuilder-wizard .gfb__footer.wizard__footer .submit');
//     var formStarted = false;
//     var formSubmitted = false;

//     function pushToDataLayer(eventData) {
//       window.dataLayer = window.dataLayer || [];
//       window.dataLayer.push(eventData);
//     }

//     function handleFormStart() {
//       if (!formStarted) {
//         formStarted = true;
//         pushToDataLayer({
//           event: "form_start",
//           content_type: "formulario_de_contacto",
//           position: "section-partner",
//           form_name: "form_partner",
//           form_id: form.closest('.globo-formbuilder')?.getAttribute("id") || "null",
//           url_destination: 'null',
//         });
//       }
//     }

//     function handleFormError() {
//       let hasErrors = false;
//       let errorFields = [];
//       let requiredFieldsArray = Array.from(requiredFields);
//       let anyRadioChecked = requiredFieldsArray.some(field => 
//         (field.name === 'radio' || field.name === 'radio-2') ? field.checked : false
//       );

//       requiredFieldsArray.forEach((field) => {             
//         if (!anyRadioChecked && (field.name === 'radio' || field.name === 'radio-2')) {   
//           hasErrors = true;    
//           errorFields.push(field.closest('.globo-form-control')?.querySelector('.classic-label.globo-label span')?.innerHTML);
//         }
//         if (!field.value) {
//           hasErrors = true;            
//           errorFields.push(field.name);                        
//         } 
//         if(field.type == 'checkbox'){
//           errorFields.push(field.value);   
//         }
//       });

//       if (hasErrors) {
//         pushToDataLayer({
//           event: "form_error",
//           content_type: "formulario_de_contacto",
//           position: "section-partner",
//           form_name: "form_partner",
//           form_id: form.closest('.globo-formbuilder')?.getAttribute("id") || "null",
//           form_error: errorFields,
//           url_destination: 'null',
//         });

//         return true;
//       }

//       return false;
//     }

//     function handleButtonClick() {
//       if (handleFormError()) {
//         console.log("Form has errors, preventing submission.");
//         return;
//       }

//       let requiredFieldsArray = Array.from(requiredFields);
//       let checkedRadioValue = null;
//       let checkedRadio2Value = null;
//       let checkedRadio3Value = null;

//       let anyRadioChecked = requiredFieldsArray.some(field => {
//         if (field.name === 'radio' && field.checked) {
//           checkedRadioValue = field.value;
//           return true;
//         }
//         if (field.name === 'radio-2' && field.checked) {
//           checkedRadio2Value = field.value;
//           return true;
//         }
//         return false;
//       });

//       requiredFieldsRadio3.forEach((field) => {
//         if (field.checked) {
//           checkedRadio3Value = field.value;
//         }
//       });

//       if (!formSubmitted) {
//         formSubmitted = true;
//         pushToDataLayer({
//           event: "form_submit",
//           content_type: "formulario_de_contacto",
//           position: 'section-partner',
//           form_name: 'form_partner',          
//           form_id: form.closest('.globo-formbuilder')?.getAttribute("id") || "null",
//           form_business: checkedRadioValue,
//           form_shop_type: checkedRadio2Value,
//           form_find_us: checkedRadio3Value,
//           url_destination: 'null',
//         });

//         // **Reset flags for the next submission**
//         setTimeout(() => {
//           formStarted = false;
//           formSubmitted = false;
//         }, 500);
//       }
//     }

//     // **Attach event listeners**
//     inputs.forEach((input) => {
//       input.addEventListener("input", handleFormStart);
//     });

//     checkboxes.forEach((checkbox) => {
//       checkbox.addEventListener("change", handleFormStart);
//     });

//     if (submitButton) {
//       submitButton.addEventListener("click", handleButtonClick);
//     } else {
//       console.error("Submit button not found");
//     }

//     // **Reset form on successful submission**
//     form.addEventListener("submit", function () {
//       setTimeout(() => {
//         formStarted = false;
//         formSubmitted = false;
//         window.location.reload(); // This reloads the page

//       }, 500);
//     });

//   }, 1000);
// })();

if (window.location.pathname == "/pages/quieres-ser-partner") {
  function globoFormHandler() {
    console.log(">>> globoFormHandler");
    var form = document.querySelector(".globo-form-app form");
    if (form.classList.contains("listener--addded")) {
      return;
    }

    var checkboxes = form.querySelectorAll("input[type='radio'], input[type='checkbox']");
    var inputs = form.querySelectorAll("input");
    var requiredFields = form.querySelectorAll(".globo-form-control input[presence]");
    var requiredFieldsRadio3 = form.querySelectorAll(".globo-form-control input[name='radio-3']");
    var submitButton = form.querySelector(".globo-formbuilder-wizard .gfb__footer.wizard__footer .submit");
    var formStarted = false;
    var formSubmitted = false;

    form.classList.add("listener--addded");

    function pushToDataLayer(eventData) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventData);
      Shopify.analytics.publish("custom_event",eventData); //push al custom event de Shopify

    }

    function handleFormStart() {
      console.log("handleFormStart :::", formStarted);
      if (!formStarted) {
        formStarted = true;
        pushToDataLayer({
          event: "form_start",
          content_type: "formulario_de_contacto",
          position: "section-partner",
          form_name: "form_partner",
          form_id: form.closest(".globo-formbuilder")?.getAttribute("id") || "null",
          url_destination: "null",
        });
      }
    }

    function handleFormError() {
      let hasErrors = false;
      let errorFields = new Set(); // Use Set to avoid duplicates
      let requiredFieldsArray = Array.from(requiredFields);
      
      let radioGroups = ["radio", "radio-2"];
      let radioGroupChecked = {};
    
      // Initialize check for each radio group
      radioGroups.forEach(group => radioGroupChecked[group] = false);
    
      requiredFieldsArray.forEach((field) => {
        if (radioGroups.includes(field.name)) {
          if (field.checked) {
            radioGroupChecked[field.name] = true;
          }
        } else if (!field.value.trim()) {
          hasErrors = true;
          errorFields.add(field.name);
        }
      });
    
      // Ensure at least one radio button is selected in each group
      radioGroups.forEach(group => {
        if (!radioGroupChecked[group]) {
          hasErrors = true;
          errorFields.add(group);
        }
      });
    
      // Handle checkboxes validation
      let checkboxesArray = Array.from(form.querySelectorAll('input[type="checkbox"][presence]'));
      checkboxesArray.forEach(checkbox => {
        if (!checkbox.checked) {
          hasErrors = true;
          errorFields.add(checkbox.name);
        }
      });
    
      if (hasErrors) {
        pushToDataLayer({
          event: "form_error",
          content_type: "formulario_de_contacto",
          position: "section-partner",
          form_name: "form_partner",
          form_id: form.closest(".globo-formbuilder")?.getAttribute("id") || "null",
          form_error: Array.from(errorFields).join(", "), // Convert Set to a concatenated string
          url_destination: "null",
        });
    
        return true;
      }
    
      return false;
    }
    
    

    function handleButtonClick() {
      console.log("handleButtonClick");
      if (handleFormError()) {
        console.log("Form has errors, preventing submission.");
        return;
      }

      let checkedRadioValue = null;
      let checkedRadio2Value = null;
      let checkedRadio3Value = null;

      requiredFields.forEach(field => {
        if (field.name === "radio" && field.checked) {
          checkedRadioValue = field.value;
        }
        if (field.name === "radio-2" && field.checked) {
          checkedRadio2Value = field.value;
        }
      });

      requiredFieldsRadio3.forEach((field) => {
        if (field.checked) {
          checkedRadio3Value = field.value;
        }
      });

      if (!formSubmitted) {
        formSubmitted = true;
        pushToDataLayer({
          event: "form_submit",
          content_type: "formulario_de_contacto",
          position: "section-partner",
          form_name: "form_partner",
          form_id: form.closest(".globo-formbuilder")?.getAttribute("id") || "null",
          form_business: checkedRadio2Value,
          form_shop_type: checkedRadioValue,
          form_find_us: checkedRadio3Value,
          url_destination: "null",
        });

        setTimeout(() => {
          formStarted = false;
          formSubmitted = false;
        }, 500);
        form.classList.remove("listener--addded");
      }
    }

    inputs.forEach((input) => {
      if (!input.classList.contains("listener--addded")) {
        input.classList.add("listener--addded");
        input.addEventListener("input", handleFormStart);
      }
    });

    checkboxes.forEach((checkbox) => {
      if (!checkbox.classList.contains("listener--addded")) {
        checkbox.classList.add("listener--addded");
        checkbox.addEventListener("change", handleFormStart);
      }
    });

    if (submitButton) {
      submitButton.addEventListener("click", handleButtonClick);
    } else {
      console.error("Submit button not found");
    }

    form.addEventListener("submit", function () {
      setTimeout(() => {
        formStarted = false;
        formSubmitted = false;
      }, 500);
    });

    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        if (mutation.type == "childList" && mutation.target.classList.contains("success") && mutation.target.classList.contains("message") && !form.classList.contains("listener--addded")) {
          setTimeout(() => {
            globoFormHandler();
          }, 3000);
        }
      });
    });

    observer.observe(form, { childList: true, subtree: true });
  }

  let globoInterval = setInterval(() => {
    if (document.querySelector(".globo-form-app form")) {
      clearInterval(globoInterval);
      globoFormHandler();
    }
  }, 500);

  window.addEventListener("load", () => {
    setTimeout(() => {
      clearInterval(globoInterval);
    }, 10000);
  });
}



//Login form
// const loginForm = document.querySelector("#customer_login");
// const loginButton = document.querySelector("#customer_login button");
// if (loginForm && loginButton) {
//   console.log(loginForm)
//   loginButton.addEventListener("click", function (e) {
//     console.log(loginButton)
//     const emailInput = document.querySelector("#input--template--24596861845883__main--customeremail");
//     const passwordInput = document.querySelector("#input--template--24596861845883__main--customerpassword");
//     console.log(emailInput)
//     console.log(passwordInput)
//     let errorType = [];
//       if (!emailInput.value.trim()) {
//           errorType.push("missing_email");
//       }
      
//       if (!passwordInput.value.trim()) {
//           errorType.push("missing_password");
//       }
      
//       if (errorType.length > 0) {
//           window.dataLayer = window.dataLayer || [];
//           window.dataLayer.push({
//               'event': 'error_login',
//               'content_type': 'iniciar_sesion',
//               'error_name': errorType.join(", ")
//           });
//           console.log("🚨 DataLayer Push:", JSON.stringify(window.dataLayer, null, 2));
//           return;
//         }
//         loginForm.submit(); 
//         window.dataLayer.push({
//           'event': 'login',
//           'content_type': 'iniciar_sesion',
//           'login_type': 'user_and_password',
//           'url_destination': null
//         });
//         console.log("🚨 DataLayer Push:", JSON.stringify(window.dataLayer, null, 2));
        
//       });
//     }

const loginForm = document.querySelector("#customer_login");
const loginButton = document.querySelector("#customer_login button");

if (loginForm && loginButton) {
  console.log(loginForm);
  
  loginButton.addEventListener("click", function (e) {
    console.log(loginButton);
    const emailInput = document.querySelector("#input--template--24596861845883__main--customeremail");
    const passwordInput = document.querySelector("#input--template--24596861845883__main--customerpassword");
    console.log(emailInput);
    console.log(passwordInput);
    
    let errorSet = new Set(); // Use Set to prevent duplicates

    if (!emailInput.value.trim()) {
      errorSet.add("missing_email");
    }
    
    if (!passwordInput.value.trim()) {
      errorSet.add("missing_password");
    }
    
    if (errorSet.size > 0) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'error_login',
        'content_type': 'iniciar_sesion',
        'error_name': Array.from(errorSet).join(", ") // Convert Set to a concatenated string
      });
      Shopify.analytics.publish("custom_event",{
        'event': 'error_login',
        'content_type': 'iniciar_sesion',
        'error_name': Array.from(errorSet).join(", ") // Convert Set to a concatenated string
      }); //push al custom event de Shopify

      console.log("🚨 DataLayer Push:", JSON.stringify(window.dataLayer, null, 2));
      return;
    }

    // If no errors, proceed with login
    loginForm.submit();
    window.dataLayer.push({
      'event': 'login',
      'content_type': 'iniciar_sesion',
      'login_type': 'user_and_password',
      'url_destination': null
    });
          Shopify.analytics.publish("custom_event",{
      'event': 'login',
      'content_type': 'iniciar_sesion',
      'login_type': 'user_and_password',
      'url_destination': null
    }); //push al custom event de Shopify
    console.log("🚨 DataLayer Push:", JSON.stringify(window.dataLayer, null, 2));
  });
}



//Registration form (entire website)
const RegistrationForm = document.querySelector("#create_customer");

if (RegistrationForm) {
  const RegistrationButton = RegistrationForm.querySelector("#create_customer button");
  RegistrationButton.addEventListener("click", function (e) {
    e.preventDefault(); // Prevent form submission for validation
    
    const firstNameInput = RegistrationForm.querySelector(`[name="customer[first_name]"]`);
    const lastNameInput = RegistrationForm.querySelector(`[name="customer[last_name]"]`);
    const emailInput = RegistrationForm.querySelector(`[name="customer[email]"]`);
    const passwordInput = RegistrationForm.querySelector(`[name="customer[password]"]`);
    const termsCheckbox = RegistrationForm.querySelector("#register_agree");

    let errorSet = new Set(); // Use Set to avoid duplicate errors

    if (!firstNameInput || !firstNameInput.value.trim()) {
      errorSet.add("missing_first_name");
    }
    if (!lastNameInput || !lastNameInput.value.trim()) {
      errorSet.add("missing_last_name");
    }
    if (!emailInput || !emailInput.value.trim()) {
      errorSet.add("missing_email");
    }
    if (!passwordInput || !passwordInput.value.trim()) {
      errorSet.add("missing_password");
    }
    if (termsCheckbox && !termsCheckbox.checked) {
      errorSet.add("terms_not_accepted");
      termsCheckbox.classList.add("not-selected");
      setTimeout(() => {
        termsCheckbox.nextElementSibling.style.display = "block";
      }, 100);
    }

    if(termsCheckbox.checked == true){
      termsCheckbox.classList.remove("not-selected");
      termsCheckbox.nextElementSibling.style.display = "none";
    }

    window.dataLayer = window.dataLayer || [];

    if (errorSet.size > 0) {
      window.dataLayer.push({
        event: "error_register",
        content_type: "crear_cuenta",
        error_name: Array.from(errorSet).join(", ") // Convert Set to concatenated string
      });
      Shopify.analytics.publish("custom_event",{
        event: "error_register",
        content_type: "crear_cuenta",
        error_name: Array.from(errorSet).join(", ") // Convert Set to concatenated string
      }); //push al custom event de Shopify
      console.log("🚨 DataLayer Push:", JSON.stringify(window.dataLayer, null, 2));
      return; // Stop submission if errors exist
    }

    // 🚀 Successful Registration Event
    window.dataLayer.push({
      event: "register",
      content_type: "crear_cuenta",
      login_type: "user_and_password",
      url_destination: window.location.href
    });
              Shopify.analytics.publish("custom_event",{
      event: "register",
      content_type: "crear_cuenta",
      login_type: "user_and_password",
      url_destination: window.location.href
    }); //push al custom event de Shopify

    // 🔄 Submit the form
    RegistrationForm.submit();
  });
}


//REWARDS
function trackButtons(containerSelector, contentType) {
  setTimeout(() => {
    let container = document.querySelector(containerSelector);
    if (!container) {
      console.warn(`Container not found for:`);
      return;
    }

    if (container.shadowRoot) {
      container = container.shadowRoot;
    }

    let listItems = container.querySelectorAll(".gw-rd-list__item");

    listItems.forEach((li, index) => {
      li.addEventListener("mouseenter", () => {
        setTimeout(() => {
          let buttons = li.querySelectorAll(".gw-rd-ways-to-earn-page-widget-button-group .gw-btn.gw-btn--reset.gw-rd-action-btn");

          if (buttons.length === 0) {
            console.warn(`No buttons found in LI ${index + 1} of ${contentType}`);
            return;
          }
          
          buttons.forEach((button, btnIndex) => {
            button.style.display = "block";
            button.style.opacity = "1";

            button.addEventListener("click", () => {
              let buttonText = button.querySelector(".gw-layout-text")?.innerText || "No text found";
              let h2Text = li.querySelector("h2.gw-layout-text")?.innerText || "No H2 found";
              let urlDestination = "https://ysabelmora.com/account/register";
              if (buttonText.toLowerCase() === "acceso") {
                urlDestination = "https://ysabelmora.com/account/login";
              }
              window.dataLayer.push({
                'event': 'select_content',
                'content_type': `${h2Text} ${contentType}`,
                'action_type': `click_on_${buttonText}`,
                'element': 'button',
                'position': 'body_card',
                'link_text': buttonText,
                'url_destination': urlDestination
              });
              Shopify.analytics.publish("custom_event",{
                'event': 'select_content',
                'content_type': `${h2Text} ${contentType}`,
                'action_type': `click_on_${buttonText}`,
                'element': 'button',
                'position': 'body_card',
                'link_text': buttonText,
                'url_destination': urlDestination
              }); //push al custom event de Shopify
            });
          });
        }, 1000);
      });
    });
  }, 2000);
}
trackButtons(".container .shopify-block .gw-rd-ways-to-earn-page-widget-placeholder", "card + coupon_rewards");
trackButtons(".container .shopify-block .gw-rd-ways-to-spend-page-widget-placeholder", "card + coupon_rewards");


//WISHLIST. REMOVE_FROM_WISHLIST

// let attemptsWishlist = 0;
// const maxAttemptsWishlist = 10;

// const wishlistInterval = setInterval(() => {
//   let wishlistContainer = document.querySelector(".gw-wl-page-placeholder");

//   if (wishlistContainer && wishlistContainer.shadowRoot) {
//     let shadowRoot = wishlistContainer.shadowRoot;
//     let wishlistItems = shadowRoot.querySelectorAll(".gw-wl-page-list__item-wrapper");

//     console.log("Wishlist Items:", wishlistItems.length);

//     if (wishlistItems.length > 0) {
//       let buttons = shadowRoot.querySelectorAll(".gw-btn.gw-btn--reset.gw-btn-with-icon");

//       if (buttons.length > 0) {
//         buttons.forEach((button, index) => {
//           let svgPath = button.querySelector("svg path");

//           if (svgPath) {
//             let dValue = svgPath.getAttribute("d");

//             if (dValue.includes("M6 12.001C6 11.4487")) {
//               console.log(`Minus (-) Button ${index + 1} Found`);
//               button.dataset.type = "minus";
//             } 
            
//             if (dValue.includes("M13 7.00098")) {
//               console.log(`Plus (+) Button ${index + 1} Found`);
//               button.dataset.type = "plus";
//             }
//           }

//           button.removeEventListener("click", handleWishlistButtonClick);
//           button.addEventListener("click", handleWishlistButtonClick);
//         });

//         clearInterval(wishlistInterval);
//       }
//     }
//   }

//   attemptsWishlist++;
//   if (attemptsWishlist >= maxAttemptsWishlist) {
//     clearInterval(wishlistInterval);
//     console.log("Wishlist buttons not found after multiple attempts.");
//   }
// }, 500);

// function handleWishlistButtonClick(event) {
//   let buttonType = event.currentTarget.dataset.type;
//   let wishlistItem = event.currentTarget.closest(".gw-wl-page-item");
//   if (!wishlistItem) return;
//   let productName = wishlistItem.querySelector(".gw-wl-page-item__title")?.textContent.trim() || "";
//   let productID = wishlistItem.getAttribute("data-gw-product-id") || "";
//   let variantID = wishlistItem.getAttribute("data-gw-variant-id") || "";
//   let productPrice = wishlistItem.querySelector(".gw-wl-page-item-price")?.textContent;
//   let productImage = wishlistItem.querySelector(".gw-image__img")?.getAttribute("src") || "";
//   let productURL = wishlistItem.querySelector(".gw-wl-page-item__title")?.getAttribute("href") || "";
//   let categories = Array.from(wishlistItem.querySelectorAll(".gw-wl-page-item-content__options-item-value")).map(el => el.textContent.trim());

//   if (buttonType === "minus") {
//     setTimeout(() => {
//       window.dataLayer = window.dataLayer || [];
//       window.dataLayer.push({
//         event: "remove_from_wishlist",
//         url_destination: null,
//         ecommerce: {
//           value: productPrice,
//           currency: "EUR",
//           items: [{
//             item_name: productName,
//             item_id: productID,
//             value: productPrice,
//             currency: "EUR",
//             index: "null",
//             price_original: productPrice,
//             price: productPrice,
//             discount: null,
//             coupon: null,
//             quantity: 1,
//             item_category: categories[0] || "",
//             item_category2: categories[1] || "",
//             item_category3: categories[2] || "",
//             item_category4: categories[3] || "",
//             item_variant: variantID,
//             image_url: productImage,
//             product_url: productURL
//           }]
//         }
//       });

//       console.log("Item removed from wishlist:", productName, window.dataLayer);
//     }, 500);
//   }
// }




// Remove WhishList

// let attemptsWishlist = 0;
// const maxAttemptsWishlist = 10;

// const wishlistInterval = setInterval(() => {
//   let wishlistContainer = document.querySelector(".gw-wl-page-placeholder");

//   if (!wishlistContainer?.shadowRoot) return; // ✅ Ensure shadowRoot exists before accessing it

//   let shadowRoot = wishlistContainer.shadowRoot;
//   let wishlistItems = shadowRoot.querySelectorAll(".gw-wl-page-list__item-wrapper");

//   console.log("Wishlist Items:", wishlistItems.length);

//   if (wishlistItems.length > 0) {
//     let buttons = shadowRoot.querySelectorAll(".gw-actions-popover .gw-action-item__btn");

//     if (buttons.length > 0) {
//       buttons.forEach((button) => {
//         button.removeEventListener("click", handleWishlistButtonClick); // Remove old listeners
//         button.addEventListener("click", handleWishlistButtonClick, { once: true }); // Ensure event fires once per click
//       });

//       // ❌ Don't clear the interval immediately; keep checking for new items
//     }
//   }

//   attemptsWishlist++;
//   if (attemptsWishlist >= maxAttemptsWishlist) {
//     clearInterval(wishlistInterval);
//     console.log("Wishlist buttons not found after multiple attempts.");
//   }
// }, 500);

// function handleWishlistButtonClick(event) {
//   event.preventDefault();
  
//   let wishlistItem = event.currentTarget.closest(".gw-wl-page-item") || 
//                      event.currentTarget.closest("shadowRoot .gw-wl-page-item"); // ✅ Handle shadowRoot case
//   if (!wishlistItem) return;

//   let productName = wishlistItem.querySelector(".gw-wl-page-item__title")?.textContent.trim() || "";
//   let productID = wishlistItem.getAttribute("data-gw-product-id") || "";
//   let variantID = wishlistItem.getAttribute("data-gw-variant-id") || "";
//   let productPrice = parseFloat(
//     wishlistItem.querySelector(".gw-wl-page-item-price")?.textContent.replace(/[^\d.]/g, "") // ✅ Ensure valid price format
//   ) || 0;
//   let productImage = wishlistItem.querySelector(".gw-image__img")?.getAttribute("src") || "";
//   let productURL = wishlistItem.querySelector(".gw-wl-page-item__title")?.getAttribute("href") || "";
//   let categories = Array.from(wishlistItem.querySelectorAll(".gw-wl-page-item-content__options-item-value")).map(el => el.textContent.trim());

//   setTimeout(() => {
//     window.dataLayer = window.dataLayer || [];
//     window.dataLayer.push({
//       event: "remove_from_wishlist",
//       url_destination: null,
//       ecommerce: {
//         value: productPrice,
//         currency: "EUR",
//         items: [{
//           item_name: productName,
//           item_id: productID,
//           value: productPrice,
//           currency: "EUR",
//           index: null, // ✅ Use null instead of "null"
//           price_original: productPrice,
//           price: productPrice,
//           discount: null,
//           coupon: null,
//           quantity: 1,
//           item_category: categories[0] || "",
//           item_category2: categories[1] || "",
//           item_category3: categories[2] || "",
//           item_category4: categories[3] || "",
//           item_variant: variantID,
//           image_url: productImage,
//           product_url: productURL
//         }]
//       }
//     });

//     console.log("Item removed from wishlist:", productName, window.dataLayer);
//   }, 500);
// }

// Remove WhishList
function observeShadowRoots(root) {
  const observer = new MutationObserver(() => {
    WhishList(); // Re-attach event listeners when shadow DOM changes
  });

  observer.observe(root, { childList: true, subtree: true });
}

function WhishList() {
  let attemptsWishlist = 0; 
  const maxAttemptsWishlist = 10;

  const wishlistInterval = setInterval(() => {
    const wishlistContainer = document.querySelector(".gw-wl-page-placeholder");

    if (!wishlistContainer?.shadowRoot) return; // Ensure shadowRoot exists

    const shadowRoot = wishlistContainer.shadowRoot;
    const wishlistItems = shadowRoot.querySelectorAll(".gw-wl-page-list__item-wrapper");

    if (wishlistItems.length > 0) {
      const buttons = shadowRoot.querySelectorAll(".gw-actions-popover .gw-action-item__btn");

      if (buttons.length > 0) {
        buttons.forEach((button) => {
          button.removeEventListener("click", handleWishlistButtonClick);
          button.addEventListener("click", handleWishlistButtonClick, { once: true });
        });
      }

      // Start observing shadow DOM mutations
      observeShadowRoots(shadowRoot);
    }
  }, 500);

  attemptsWishlist++;
  if (attemptsWishlist >= maxAttemptsWishlist) {
    clearInterval(wishlistInterval);
    console.log("Wishlist buttons not found after multiple attempts.");
  }
}

function handleWishlistButtonClick(event) {
  event.preventDefault();

  const wishlistItem = event.currentTarget.closest(".gw-wl-page-item") ||
    event.currentTarget.closest("shadowRoot .gw-wl-page-item");
  if (!wishlistItem) return;

  const productName = wishlistItem.querySelector(".gw-wl-page-item__title")?.textContent.trim() || "";
  const productID = wishlistItem.getAttribute("data-gw-product-id") || "";
  const variantID = wishlistItem.getAttribute("data-gw-variant-id") || "";
  let slectedcurrancy = document.querySelector(".md-form__select__country__list-link").getAttribute("data-currency");
  const productPriceText = wishlistItem.querySelector(".gw-wl-page-item-price")?.textContent || "0";
  const numericPrice = parseFloat(productPriceText.replace(/[^\d,.-]+/g, '').replace(',', '.')) || 0;
  let productPrice = numericPrice + " " + slectedcurrancy

  // const productPrice = wishlistItem.querySelector(".gw-wl-page-item-price")?.textContent  || 0;
  // const productPrice = parseFloat(wishlistItem.querySelector(".gw-wl-page-item-price")?.textContent.replace(/[^\d.]/g, "")) || 0;
  const productImage = wishlistItem.querySelector(".gw-image__img")?.getAttribute("src") || "";
  const productURL = wishlistItem.querySelector(".gw-wl-page-item__title")?.getAttribute("href") || "";
  const categories = Array.from(
    wishlistItem.querySelectorAll(".gw-wl-page-item-content__options-item-value")
  ).map(el => el.textContent.trim());

  setTimeout(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "remove_from_wishlist",
      url_destination: "https://ysabelmora.com/pages/wishlist",
      ecommerce: {
        value: productPrice,
        currency: "EUR",
        items: [{
          item_name: productName,
          item_id: productID,
          value: productPrice,
          currency: "EUR",
          index: null,
          price_original: productPrice,
          price: productPrice,
          discount: null,
          coupon: null,
          quantity: 1,
          item_category: categories[0] || "",
          item_category2: categories[1] || "",
          item_category3: categories[2] || "",
          item_category4: categories[3] || "",
          item_variant: variantID,
          // image_url: productImage,
          // product_url: productURL
        }]
      }
    });
    Shopify.analytics.publish("custom_event",{
      event: "remove_from_wishlist",
      url_destination: "https://ysabelmora.com/pages/wishlist",
      ecommerce: {
        value: productPrice,
        currency: "EUR",
        items: [{
          item_name: productName,
          item_id: productID,
          value: productPrice,
          currency: "EUR",
          index: null,
          price_original: productPrice,
          price: productPrice,
          discount: null,
          coupon: null,
          quantity: 1,
          item_category: categories[0] || "",
          item_category2: categories[1] || "",
          item_category3: categories[2] || "",
          item_category4: categories[3] || "",
          item_variant: variantID,
          // image_url: productImage,
          // product_url: productURL
        }]
      }
    }); //push al custom event de Shopify

    console.log("Item removed from wishlist:", productName, window.dataLayer);
  }, 500);
}

// MutationObserver to detect changes in the light DOM
const observer = new MutationObserver(() => {
  WhishList(); // Trigger wishlist check on DOM mutation
});

observer.observe(document.body, { childList: true, subtree: true });

// Run the function once on page load
WhishList();

//new whishlist page start 

{
  function observeShadowRoots(root) {
    const observer = new MutationObserver(() => {
      newWhishList(); // Re-attach event listeners when shadow DOM changes
    });
  
    observer.observe(root, { childList: true, subtree: true });
  }
  
  function newWhishList() {
    let attemptsWishlist = 0; 
    const maxAttemptsWishlist = 10;
  
    const wishlistInterval = setInterval(() => {
      const wishlistContainer = document.querySelector(".gw-wl-page-placeholder");
  
      if (!wishlistContainer?.shadowRoot) return; // Ensure shadowRoot exists
  
      const shadowRoot = wishlistContainer.shadowRoot;
      const wishlistItems = shadowRoot.querySelectorAll(".gw-wl-page-item");
      // console.log(wishlistItems,"wishlistItems")
  
      if (wishlistItems.length > 0) {
        const buttons = shadowRoot.querySelectorAll(".gw-wl-page-item__delete-btn");
      // console.log(buttons,"=========>")
        
  
        if (buttons.length > 0) {
          buttons.forEach((button) => {
            button.removeEventListener("click", handleWishlistButtonClick);
            button.addEventListener("click", handleWishlistButtonClick, { once: true });
          });
        }
  
        // Start observing shadow DOM mutations
        observeShadowRoots(shadowRoot);
      }
    }, 500);
  
    attemptsWishlist++;
    if (attemptsWishlist >= maxAttemptsWishlist) {
      clearInterval(wishlistInterval);
      console.log("Wishlist buttons not found after multiple attempts.");
    }
  }
  
  function handleWishlistButtonClick(event) {
    event.preventDefault();
  
    const wishlistItem = event.currentTarget.closest(".gw-wl-page-item") ||
      event.currentTarget.closest("shadowRoot .gw-wl-page-item");
    if (!wishlistItem) return;
  
    const productName = wishlistItem.querySelector(".gw-wl-page-item__title")?.textContent.trim() || "";
    const productID = wishlistItem.getAttribute("data-gw-product-id") || "";
    const variantID = wishlistItem.getAttribute("data-gw-variant-id") || "";
    let slectedcurrancy = document.querySelector(".md-form__select__country__list-link").getAttribute("data-currency");
    const productPriceText = wishlistItem.querySelector(".gw-wl-page-item-price")?.textContent || "0";
    const numericPrice = parseFloat(productPriceText.replace(/[^\d,.-]+/g, '').replace(',', '.')) || 0;
    let mainPrice = numericPrice + " " + slectedcurrancy
    
    // const productPrice = (wishlistItem.querySelector(".gw-wl-page-item-price")?.textContent.replace(/[^\d.]/g, "")) || 0;
    const productImage = wishlistItem.querySelector(".gw-image__img")?.getAttribute("src") || "";
    const productURL = wishlistItem.querySelector(".gw-wl-page-item__title")?.getAttribute("href") || "";
    const categories = Array.from(
      wishlistItem.querySelectorAll(".gw-wl-page-item-content__options-item-value")
    ).map(el => el.textContent.trim());
  
    setTimeout(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "remove_from_wishlist",
        url_destination: "https://ysabelmora.com/pages/wishlist",
        ecommerce: {
          value: mainPrice,
          currency: slectedcurrancy,
          items: [{
            item_name: productName,
            item_id: productID,
            value: mainPrice,
            currency: slectedcurrancy,
            index: null,
            price_original: mainPrice,
            price: mainPrice,
            discount: null,
            coupon: null,
            quantity: 1,
            item_category: categories[0] || "",
            item_category2: categories[1] || "",
            item_category3: categories[2] || "",
            item_category4: categories[3] || "",
            item_variant: variantID,
            // image_url: productImage,
            // product_url: productURL
          }]
        }
      });
      Shopify.analytics.publish("custom_event",{
        event: "remove_from_wishlist",
        url_destination: "https://ysabelmora.com/pages/wishlist",
        ecommerce: {
          value: mainPrice,
          currency: slectedcurrancy,
          items: [{
            item_name: productName,
            item_id: productID,
            value: mainPrice,
            currency: slectedcurrancy,
            index: null,
            price_original: mainPrice,
            price: mainPrice,
            discount: null,
            coupon: null,
            quantity: 1,
            item_category: categories[0] || "",
            item_category2: categories[1] || "",
            item_category3: categories[2] || "",
            item_category4: categories[3] || "",
            item_variant: variantID,
            // image_url: productImage,
            // product_url: productURL
          }]
        }
      }); //push al custom event de Shopify
  
      console.log("Item removed from wishlist:", productName, window.dataLayer);
    }, 500);
  }
  
  // MutationObserver to detect changes in the light DOM
  const newobserver = new MutationObserver(() => {
    newWhishList(); // Trigger wishlist check on DOM mutation
  });
  
  newobserver.observe(document.body, { childList: true, subtree: true });
  
  // Run the function once on page load
  newWhishList();
}
//new whishlist page end






//WISHLIST. SELECT_CONTENT
let attemptsq = 0;
const maxAttemptsq = 10;

const ssetIntervals = setInterval(() => {
  let wishlistContainer = document.querySelector(".gw-wl-page-placeholder");
  if (wishlistContainer && wishlistContainer.shadowRoot) {
    let shadowRoot = wishlistContainer.shadowRoot;
    let wishlistButton = shadowRoot.querySelector(".gw-wl-page__subheader");

    if (wishlistButton) {
      console.log("Wishlist Button Found, Adding Event Listener");
      shadowRoot.removeEventListener("click", handleWishlistClick);
      shadowRoot.addEventListener("click", handleWishlistClick);
      clearInterval(ssetIntervals);
    }
  }

  attemptsq++;
  if (attemptsq >= maxAttemptsq) {
    clearInterval(ssetIntervals);
    console.log("Wishlist button not found after multiple attempts.");
  }
}, 500);

function handleWishlistClick(event) {
  let addButton = event.target.closest(".gw-btn.gw-btn--reset.gw-button.--contained.--large.--rounded");

  if (addButton) {
    console.log("Button Clicked:", addButton);

    setTimeout(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "select_content",
        content_type: "my_wishlist",
        action_type: "create_new_list",
        element: addButton,
        position: "body-section_new_list",
        url_destination: null,
      });
          Shopify.analytics.publish("custom_event",{
        event: "select_content",
        content_type: "my_wishlist",
        action_type: "create_new_list",
        element: addButton,
        position: "body-section_new_list",
        url_destination: null,
      });
    }, 300);
  }
}


//YMleclub POPUP
let attempts = 0;
const maxAttempts = 10; 
const intervalss = setInterval(() => {
  let widget = document.querySelector(".gw-rd-popup-widget-placeholder");
  console.log(widget,"============>")
  if (widget && widget.shadowRoot) {
    let buttons = widget.shadowRoot.querySelectorAll(".gw-btn");

    buttons.forEach((button) => {
      let text = button.textContent.trim().toLowerCase(); 
      if (text === "únete ahora" || text === "iniciar sesión") {
        console.log(`Button Found: ${text}`, button);
        button.removeEventListener("click", handleButtonClick);
        button.addEventListener("click", handleButtonClick);
      }
    });
    clearInterval(intervalss);
  }

  attempts++;
  if (attempts >= maxAttempts) {
    clearInterval(intervalss);
    console.log("Buttons not found after multiple attempts.");
  }
}, 3000);

function handleButtonClick(event) {
  console.log("Button clicked:", event.target.textContent.trim());

  setTimeout(() => {
    let text = event.target.textContent.trim().toLowerCase();
    let eventData = {
      event: "select_content",
      content_type: "bienvenido_a_ymleclub",
      action_type: text === "únete ahora" ? "click_on_join" : "click_on_login",
      element: event.target,
      position: "my_points_pop_up",
      link_text: text,
      url_destination: text === "iniciar sesión" ? "https://ysabelmora.com/account/login" : null,
    };

    console.log("Pushing to dataLayer:", eventData);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);
    Shopify.analytics.publish("custom_event",eventData);
  }, 3000);
}


//WhatsApp
const whatsappLink = document.querySelector(".whatsapp_main a");
if (whatsappLink) {
   whatsappLink.addEventListener("click", function (e) { 
      console.log(whatsappLink.href, "clclcl");
      window.dataLayer.push({
        'event': 'contact',
        'content_type': "whastapp" ,
        'action_type': 'click_on_whatsapp_pop_up',
        'element' : 'link',
        'position' : 'whatsapp_pop_up',
        'url_destination' : whatsappLink.href
    });
     Shopify.analytics.publish("custom_event",{
        'event': 'contact',
        'content_type': "whastapp" ,
        'action_type': 'click_on_whatsapp_pop_up',
        'element' : 'link',
        'position' : 'whatsapp_pop_up',
        'url_destination' : whatsappLink.href
    });
   });
}



let actionType = null;
let searchedTerm;
let urlDestination;
let contentType;

const attachedInputs = new Set();
const attachedButtons = new Set();
const attachedFilters = new Set();

function attachSearchListener(searchInput) {
  if (!attachedInputs.has(searchInput)) {
    attachedInputs.add(searchInput); // Prevent duplicate event listeners

    let debounceTimer;
    searchInput.addEventListener("input", (event) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        function getQueryParamFromHash(param) {
          let hashPart = window.location.hash.split("#")[1];
          if (!hashPart) return null;
          let params = new URLSearchParams(hashPart);
          return params.get(param);
        }
        searchedTerm = getQueryParamFromHash("q") || searchInput.value.replace(/ /g, "_").toLowerCase().trim();
        urlDestination = `${window.location.href}#eea2/fullscreen/m=and&q=${encodeURIComponent(searchInput.value.trim())}`;
        actionType = "search";
        contentType = 'search_box';
        showContent(searchedTerm,contentType,actionType,urlDestination)
      }, 2000);
    });
  }
}

function attachSuggestionListeners() {
  document.querySelectorAll(".dfd-suggestion-button button").forEach((button) => {
    if (!attachedButtons.has(button)) {
      attachedButtons.add(button); 

      button.addEventListener("click", (event) => {
        const spanElement = event.currentTarget.querySelector("span");
        if (spanElement) {
          searchedTerm = spanElement.textContent.replace(/ /g, "_").toLowerCase();
          setTimeout(() => {
            urlDestination = `${window.location.href}#eea2/fullscreen/m=and&q=${encodeURIComponent(spanElement.textContent.trim())}`;
            actionType = "search";
            contentType = 'search_box';
            showContent(searchedTerm,contentType,actionType,urlDestination);
          },2000)
        }
      });
    }
  });
}

function attachGuidedFiltersListeners() {
  document.querySelectorAll(".dfd-suggestion-link button").forEach((button) => {
    if (!attachedButtons.has(button)) {
      attachedButtons.add(button); // Mark button as attached

      button.addEventListener("click", (event) => {
        const spanElement = event.currentTarget.querySelector("span");
        if (spanElement) {
          searchedTerm = spanElement.textContent.replace(/ /g, "_").toLowerCase();
          setTimeout(() => {
            urlDestination = `${window.location.href}#eea2/fullscreen/m=and&q=${encodeURIComponent(spanElement.textContent)}`;
            actionType = "search";
            contentType = "search_box"
            showContent(searchedTerm,contentType,actionType,urlDestination);
          }, 2000);
        }
      });
    }
  });
}

function showContent(searchedTerm,contentType,actionType,urlDestination){
  console.log("search- Search Term:", searchedTerm);
  console.log("search- Contant Type:", contentType);
  console.log("search-Action Type:", actionType);
  console.log("search-URL:", urlDestination);
  dataLayer.push({ecommerce:null});
  window.dataLayer.push({
    'event': 'search',
    'search_term': searchedTerm,
    'content_type': contentType,
    'action_type' : actionType,
    'url_destination' : urlDestination
  });
}
// function contentTypeListeners() {
//   document.querySelectorAll('button[dfd-click="filter"]').forEach((button) => {
//     if (!attachedButtons.has(button)) {
//       attachedButtons.add(button);
//       button.addEventListener("click", (event) =>{
//         setTimeout(() => {
//           function getQueryParamFromHash(param) {
//             let hashPart = window.location.hash.split("#")[1];
//             if (!hashPart) return null;
//             let params = new URLSearchParams(hashPart);
//             return params.get(param);
//           }
//           searchedTerm = getQueryParamFromHash("q");
//           urlDestination = window.location.href;
//           contentType = 'term_filter';
//           actionType = actionType;
//           showContent(searchedTerm,contentType,actionType,urlDestination);
//         }, 2000);
//       });
//     } 
//   });
// }

// function sliderTypeListeners() {
//   setTimeout(() => {
//     const slider = document.querySelector('.dfd-slider');
//     if (!slider) {
//       console.log("not slider"); 
//       return; // Exit if the slider is not found
//     }

//     const minHandle = slider.querySelector('.dfd-slider-handle-lower');
//     const maxHandle = slider.querySelector('.dfd-slider-handle-upper');

//     if (!minHandle || !maxHandle) {
//       console.log("Handles not found");
//       return; // Exit if handles are missing
//     }

//     if (!attachedButtons.has(slider)) {
//       attachedButtons.add(slider);

//       const updateValues = () => {
//         const minValue = minHandle.getAttribute('aria-valuenow');
//         const maxValue = maxHandle.getAttribute('aria-valuenow');

//         setTimeout(() => {
//           function getQueryParamFromHash(param) {
//             let hashPart = window.location.hash.split("#")[1];
//             if (!hashPart) return null;
//             let params = new URLSearchParams(hashPart);
//             return params.get(param);
//           }

//           searchedTerm = getQueryParamFromHash("q");
//           contentType = 'range_slider_change';
//           actionType = actionType;
//           urlDestination = window.location.href;
//           showContent(searchedTerm, contentType, actionType, urlDestination);
//         }, 2000);
//       };

//       minHandle.addEventListener('mousedown', function () {
//         document.addEventListener('mousemove', updateValues);
//       });

//       maxHandle.addEventListener('mousedown', function () {
//         document.addEventListener('mousemove', updateValues);
//       });

//       document.addEventListener('mouseup', function () {
//         document.removeEventListener('mousemove', updateValues);
//       });
//     }
//   }, 3000);
// }

function filterListeners() {
  document.querySelectorAll('button[dfd-click="filter"]').forEach((button) => {
    if (!attachedFilters.has(button)) {
      attachedFilters.add(button);
      button.addEventListener("click", (event) =>{
        let searchItem = document.querySelector(".dfd-searchbox-input")?.value.replace(/ /g, "_").toLowerCase().trim();
        let clickedButton = event.currentTarget;

        if (clickedButton.classList.contains("dfd-is-selected")) {
          console.log("Button already selected, skipping execution.");
          return;
        }
        setTimeout(() => {
          function getQueryParamFromHash(param) {
            let hashPart = window.location.hash.split("#")[1];
            if (!hashPart) return null;
            let params = new URLSearchParams(hashPart);
            return params.get(param);
          }
          // let filterName = 'Tipo de producto';
          // console.log(button,"=============>")
          // console.log(button.closest(".dfd-aside"))
          // filterName = button.closest('.dfd-facet').querySelector('.dfd-facet-title span');
          let filterNameElement = button.closest('.dfd-facet')?.querySelector('.dfd-facet-title span');
          let filterName = filterNameElement ? filterNameElement.textContent?.replace(/ /g, "_").toLowerCase().trim() : "tipo_de_producto";

       
          if (filterName == 'Edad y Género'){
            filterName = 'género';
          }
          let filterValue = button.querySelector('span').innerText.replace(/ /g, "_").toLowerCase();
          if(filterName == 'Color'){
            filterValue = button.querySelector('span').getAttribute('title').value.replace(/ /g, "_").toLowerCase()
          }
          searchedTerm = getQueryParamFromHash("q") || searchItem;
          filterEvent(searchedTerm,filterName,filterValue);
        }, 2000);
      });
    }
  });
}

function sliderFilterListeners() {
  setTimeout(() => {
    const slider = document.querySelector('.dfd-slider');
    if (!slider) { 
      return; // Exit if the slider is not found
    }

    const minHandle = slider.querySelector('.dfd-slider-handle-lower');
    const maxHandle = slider.querySelector('.dfd-slider-handle-upper');

    if (!minHandle || !maxHandle) {
      console.log("Handles not found");
      return; // Exit if handles are missing
    }

    if (!attachedButtons.has(slider)) {
      attachedButtons.add(slider);

      const updateValues = () => {
        const minValue = minHandle.getAttribute('aria-valuenow');
        const maxValue = maxHandle.getAttribute('aria-valuenow');

        setTimeout(() => {
        let searchItem = document.querySelector(".dfd-searchbox-input")?.value.replace(/ /g, "_").toLowerCase().trim();
          function getQueryParamFromHash(param) {
            let hashPart = window.location.hash.split("#")[1];
            if (!hashPart) return null;
            let params = new URLSearchParams(hashPart);
            return params.get(param);
          }

          const searchedTerm = getQueryParamFromHash("q") || searchItem;
         let filterName = slider.closest('.dfd-facet')?.querySelector('.dfd-facet-title span')?.innerText.replace(/ /g, "_").toLowerCase() ?? 'precio';


          // let filterName = slider.closest('.dfd-facet').querySelector('.dfd-facet-title span').innerText;
          // let filterName = slider.closest('.dfd-facet').querySelector('.dfd-facet-title span').innerText;
          let filterValue = {
            min: minValue,
            max: maxValue
          };
          filterEvent(searchedTerm,filterName,filterValue);
        }, 2000);
      };

      minHandle.addEventListener('mousedown', function () {
        document.addEventListener('mousemove', updateValues);
      });

      maxHandle.addEventListener('mousedown', function () {
        document.addEventListener('mousemove', updateValues);
      });

      document.addEventListener('mouseup', function () {
        document.removeEventListener('mousemove', updateValues);
      });
    }
  }, 3000);
}

function filterEvent(searchedTerm,filterName,filterValue) {
  console.log('--------------------------------------------------------------------')
  console.log("filter-> Search Term:", searchedTerm);
  console.log("filter-> Contant Type:", 'search_section');
  console.log("filter->  filter name:",filterName);
  console.log("filter-> filter value:",filterValue);
  window.dataLayer.push({
    'event': 'select_filter',
    'search_term': searchedTerm,
    'content_type': 'search_section',
    'filter_name': filterName,
    'filter_value': filterValue
  });
}

// Observe changes in the DOM
const observers = new MutationObserver(() => {
  const searchInput = document.querySelector(".dfd-searchbox-input");
  if (searchInput) attachSearchListener(searchInput); 

  attachSuggestionListeners(); 
  attachGuidedFiltersListeners();
  const slider = document.querySelector(".dfd-slider");
  if (slider) {
    sliderFilterListeners();
  }
});

observers.observe(document.body, { childList: true, subtree: true });

/**
 * GTM Custom Event;
 */

//view alerts
if(document.querySelector('[name="checkout"]')){ 
  document.querySelector('[name="checkout"]').addEventListener('click', function(event){
  });
}

function side_cart_checkout_button(detail){
  let side_cart_agree = detail.wrapper.querySelector("#side_cart_agree");
  console.log("side_cart_agree :: ",side_cart_agree,side_cart_agree.checked)
  if(side_cart_agree.checked == false){
    side_cart_agree.classList.add("not-selected");
    side_cart_agree.nextElementSibling.style.display = "block";
    
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then((cart) => {   
      const googleAnalyticsProducts = [];
      cart.items.forEach((item, index) => {
        console.log('ITEM',item);
        const lineItem = {
          'item_id': item.id,
          'item_name': item.title,
          'affiliation': 'ysabelmora',
          'index': index + 1,
          'item_brand': item.vendor,
          'item_category': item.product_type || 'Default',
          'item_variant': item.variant_title,
          'price': item.final_price / 100,
          'quantity': item.quantity,
          'currency': cart.currency || 'EUR'
        };
        googleAnalyticsProducts.push(lineItem);
      });
      
      const dataLayerObj = {
        'event': 'view_alert',     
        'content_type': 'error notification',
        'link_text': 'selecciona_esta_castilla_de_verificacion_si_quieres_continuar',
        'url_destination': 'https://ysabelmora.com/checkouts/cn/ZZSDI2Ng/information',
        'ecommerce': {
          'currency': cart.currency || 'EUR',
          'value': cart.total_price / 100,
          'items': googleAnalyticsProducts
        },
      };
    
      window.dataLayer.push({ 'ecommerce': null });
      window.dataLayer.push(dataLayerObj);
      Shopify.analytics.publish("custom_event", { 'ecommerce': null });//push al custom event de Shopify
      Shopify.analytics.publish("custom_event", dataLayerObj); //push al custom event de Shopify
      
      console.log('Data Layer Object:', dataLayerObj);
    })
    .catch((error) => {
      console.error('Error fetching cart data:', error);
    });
    detail.event.preventDefault();
  }else{
    sideCartAgree.classList.remove("not-selected");
    sideCartAgree.nextElementSibling.style.display = "none";
    detail.element.classList.add("btn--loading");
  }
}

document.addEventListener("gtm:event-trigger", function(event) {
  console.log("GTM:: ",event)
  if(event.detail.type == "side_cart_checkout_button"){
    side_cart_checkout_button(event.detail)
  }
});